
import { defineComponent } from 'vue';
import commonApi from '@/api/common';
import moment from 'moment';

export default defineComponent({
  name: 'List',
  data() {
    const lists: Array<object> = [];
    return {
      list: lists,
    };
  },
  components: {
  },
  mounted() {
    this.getList();
  },
  methods: {
    goToDetail(item: Record<string, object>) {
      const parent = this.$parent as unknown as {[x: string]: Function};
      parent.openDetailModal(item);
    },
    getList() {
      interface Data{
        data: [];
        success: boolean;
        message: string;
      }
      commonApi.getSaasUpgradePayLists({}).then(async ({ data, success, message }: Data) => {
        if (success) {
          console.log(data);
          interface Item{
            amount: number;
            createTime: string;
          }
          data.forEach((ele: Item) => {
            const item = ele;
            const amount = ele.amount.toFixed(2);
            item.amount = amount as any;
            item.createTime = moment(ele.createTime).format('YYYY-MM-DD HH:mm:ss');
            this.list.push(item);
          });
        } else {
          console.log(message);
        }
      });
    },
  },
});
